'use client'
import { useEffect } from 'react'
import { ErrorLike } from '@apollo/client'
import { useAtom } from 'jotai'

import { useAdminFavoritesQuery } from '@docpace/shared-react-apollo'
import { ctxAdminIdAtom } from '@docpace/shared-react-atoms'

interface UseAdminFavoritesProps {
    onError?: (error: ErrorLike) => void
}

export function useFavorites(
    { onError }: UseAdminFavoritesProps = {}
){
    const [ adminId ] = useAtom(ctxAdminIdAtom)    
    const { 
        loading,
        refetch,
        favoriteDepartmentIds,
        favoritePracticeIds,
        favoriteProviderIds,
        favoriteAppointmentTypeIds,
        error,
    } = useAdminFavoritesQuery({
        variables: { adminId },
        skip: !adminId,
        fetchPolicy: 'cache-first',
    })

    useEffect(() => {
        if (error) onError?.(error)
    }, [error, onError])

    return {
        loading,
        refetch,
        favoriteDepartmentIds,
        favoritePracticeIds,
        favoriteProviderIds,
        favoriteAppointmentTypeIds,
    }
}

export default useFavorites
